import highlightFirstmv from "/assets/videos/GIS.mp4";
import highlightSectmv from "/assets/videos/Birdd.mp4";
import highlightThirdmv from "/assets/videos/vid-3.mp4";
import highlightFourthmv from "/assets/videos/vid-2.mp4";
import exploremv from "/assets/videos/BTS.mp4";
import exploremv1_2 from "/assets/videos/Plane.mp4";
import exploremv2 from "/assets/videos/Architectures.mp4";
import exploremv3 from "/assets/videos/timelapse2.mp4";
import exploremv4 from "/assets/videos/vid-1.mp4";
import exploremv5 from "/assets/videos/Neuralport.mp4";
import framemv from "/assets/images/github.png";
import reel from "/assets/videos/Reeel.mp4";
import hero from "/assets/videos/Reeel.mp4";

import apple from "/assets/images/apple.svg";
import search from "/assets/images/search.svg";
import bag from "/assets/images/bag.svg";
import watch from "/assets/images/watch.svg";
import right from "/assets/images/right.svg";
import replay from "/assets/images/replay.svg";
import play from "/assets/images/play.svg";
import pause from "/assets/images/pause.svg";

import explore1 from "/assets/images/ipl.jpg";
import explore2 from "/assets/images/Gandhi.png"; 
import explore3 from "/assets/images/GAN.png"; 
import explore4 from "/assets/images/EO.jpg"; 
import explore5 from "/assets/images/chairs.png"; 
import explore6 from "/assets/images/chairs2.png"; 
import explore7 from "/assets/images/chairs3.png"; 
import explore8 from "/assets/images/mac.png"; 
import explore9 from "/assets/images/iphone.png";
import explore10 from "/assets/images/imac.png";
import neuralPortPlot1 from "/assets/images/Neuralport.jpg";
import neuralPortPlot2 from "/assets/images/Neuralport2.jpg";
import chip from "/assets/images/ai-section2.avif";
import github from "/assets/images/newcheck.png";
import profile from "/assets/images/profile.png";

export const highlightFirstVideo = highlightFirstmv;
export const highlightSecondVideo = highlightSectmv;
export const highlightThirdVideo = highlightThirdmv;
export const highlightFourthVideo = highlightFourthmv;
export const exploreVideo = exploremv;
export const exploreVideo1_2 = exploremv1_2;
export const exploreVideo2 = exploremv2;
export const exploreVideo3 = exploremv3;
export const exploreVideo4 = exploremv4;
export const neuralportIntro = exploremv5;
export const frameVideo = framemv;
export const profileImg = profile;
export const reelM = reel;

export const appleImg = apple;
export const searchImg = search;
export const bagImg = bag;
export const watchImg = watch;
export const rightImg = right;
export const replayImg = replay;
export const playImg = play;
export const pauseImg = pause;
export const heroVideo3 = hero;

export const explore1Img = explore1;
export const explore2Img = explore2;
export const explore3Img = explore3;
export const explore4Img = explore4;
export const explore5Img = explore5;
export const explore6Img = explore6;
export const explore7Img = explore7;
export const explore8Img = explore8;
export const explore9Img = explore9;
export const explore10Img = explore10;
export const neuralPortPlot1img = neuralPortPlot1;
export const neuralPortPlot1img2 = neuralPortPlot2;
export const aiRobotImg = chip;
export const githubImg = github;
